import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=3ad6315e&scoped=true"
import script from "./Communication.vue?vue&type=script&lang=js"
export * from "./Communication.vue?vue&type=script&lang=js"
import style0 from "./Communication.vue?vue&type=style&index=0&id=3ad6315e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6315e",
  null
  
)

export default component.exports